import { render, staticRenderFns } from "./no-ui-slider.vue?vue&type=template&id=2a7a28c4&"
import script from "./no-ui-slider.vue?vue&type=script&lang=js&"
export * from "./no-ui-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports